import React, { useState, useEffect } from 'react';
import { Calendar, Upload, Image, FileText, Save, Eye } from 'lucide-react';
import axios from 'axios';
import '../css/Blog.css';
export default function Blog() {
  const [formData, setFormData] = useState({
    title: '',
    imageUrl: null,
    description: '',
    date: new Date().toISOString().split('T')[0],
    
  });
  const [blogs, setBlogs] = useState([]);
  const [imagePreview, setImagePreview] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPreview, setShowPreview] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // const handleImageUpload = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     setFormData(prev => ({
  //       ...prev,
  //       image: file
  //     }));

  //     const reader = new FileReader();
  //     reader.onload = (e) => {
  //       setImagePreview(e.target.result);
  //     };
  //     reader.readAsDataURL(file);
  //   }
  // };

  const handleImageUpload = async (e) => {
  const file = e.target.files[0];  // Only the selected image
  const imagedata = new FormData();
  imagedata.append('file', file);   // Upload just the file
  imagedata.append('upload_preset', 'unsigned_upload'); // Preset needed by Cloudinary

  const res = await fetch('https://api.cloudinary.com/v1_1/dccuq6ut4/upload', {
    method: 'POST',
    body: imagedata,
  });

  const data = await res.json();
  console.log('Uploaded Image URL:', data.secure_url); // ← You can now use this URL
  setFormData(prev => ({
        ...prev,
        imageUrl: data.secure_url
      }));
    
    const reader = new FileReader();
      reader.onload = (e) => {
        const preview = e.target.result;
        setImagePreview(preview);
        console.log('imagepreview', preview);
      };
      reader.readAsDataURL(file);


};

useEffect(() => {
  console.log("imagePreview changed:", imagePreview);
}, [imagePreview]);


  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('entered submit');
    setIsSubmitting(true);
    try {
        const res = await axios.post('/api/blogs', formData);
         setBlogs(res.data);
        alert('Blog post uploaded successfully!');
      } catch (error) {
        console.error("Error fetching members:", error);
        
    }
    setTimeout(() => {
      
      setIsSubmitting(false);
      setFormData({
        title: '',
        description: '',
        date: new Date().toISOString().split('T')[0],
        image: null
      });
      setImagePreview(null);
      setShowPreview(false);
    }, 2000);
  };

  const isFormValid =
    formData.title.trim() &&
    formData.description.trim() &&
    formData.date &&
    formData.imageUrl;

  return (
    <div className='container'>
      <div className='wrapper'>
        <div className='card'>
          <div className='header'>
            <h1 className='headerTitle'>
              <FileText size={30} /> Create New Blog Post
            </h1>
            <p className='headerSubtext'>
              Fill in the details below to publish your blog post
            </p>
          </div>

          <div className='content'>
            {/* Title */}
            <div>
              <label className='label'>Blog Title *</label>
              <input
                type="text"
                name="title"
                value={formData.title}
                onChange={handleInputChange}
                placeholder="Enter an engaging title for your blog post..."
                className='input'
              />
            </div>

            {/* Date */}
            <div>
              <label className='label'>
                <Calendar size={16} style={{ marginRight: 6 }} />
                Publication Date *
              </label>
              <input
                type="date"
                name="date"
                value={formData.date}
                onChange={handleInputChange}
                //style={styles.input}
                className='input'
              />
            </div>

            {/* Image Upload */}
            <div>
              <label className='label'>
                <Image size={16} style={{ marginRight: 6 }} />
                Featured Image *
              </label>
              <div className='uploadBox'>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleImageUpload}
                  id="image-upload"
                  style={{ display: 'none' }}
                />
                <label htmlFor="image-upload" className='uploadLabel'>
                  {imagePreview ? (
                    <div style={{ position: 'relative' }}>
                      <img
                        src={imagePreview}
                        alt="Preview"
                        //style={styles.imagePreview}
                        className='imagePreview'
                      />
                      <div className='imageOverlay'>
                        <Upload size={24} color="#fff" />
                      </div>
                    </div>
                  ) : (
                    <div style={{ textAlign: 'center' }}>
                      <Upload size={40} color="#aaa" />
                      <p className='uploadText'>Click to upload image</p>
                      <p className='uploadSubtext'>PNG, JPG, GIF up to 10MB</p>
                    </div>
                  )}
                </label>
              </div>
              {formData.imageUrl && (
                <p className='successText'>✓ {formData.imageUrl.name} uploaded</p>
              )}
            </div>

            {/* Description */}
            <div>
              <label className='label'>Blog Content *</label>
              <textarea
                name="description"
                value={formData.description}
                onChange={handleInputChange}
                placeholder="Write your blog content here..."
                rows="12"
                style={{ resize: 'vertical' }}
                className='input'
              />
              <p className='charCount'>
                {formData.description.length} characters
              </p>
            </div>

            {/* Preview Toggle */}
            <div>
              <button
                onClick={() => setShowPreview(!showPreview)}
                style={{
                  //...styles.toggleBtn,
                  opacity: isFormValid ? 1 : 0.5,
                  cursor: isFormValid ? 'pointer' : 'not-allowed'
                }}
                className='toggleBtn'
                disabled={!isFormValid}
              >
                <Eye size={16} style={{ marginRight: 6 }} />
                {showPreview ? 'Hide Preview' : 'Show Preview'}
              </button>
            </div>

            {/* Preview */}
            {showPreview && isFormValid && (
              <div className='previewBox'>
                <h3 className='previewHeading'>Preview</h3>
                <div className='previewCard'>
                  <h2 className='previewTitle'>{formData.title}</h2>
                  <p className='previewDate'>{formData.date}</p>
                  {imagePreview && (
                    <img
                      src={imagePreview}
                      alt="Preview"
                      //style={styles.previewImage}
                      className='previewImage'
                    />
                  )}
                  {formData.description.split('\n').map((paragraph, idx) => (
                    <p key={idx} className='previewText'>{paragraph}</p>
                  ))}
                </div>
              </div>
            )}

            {/* Submit Button */}
            <div className='submitBox'>
              <button
                type="button"
                onClick={(e) => handleSubmit(e)}
                disabled={!isFormValid || isSubmitting}
                style={{
                  //...styles.submitBtn,
                  background: isFormValid && !isSubmitting
                    ? 'linear-gradient(to right, #2563eb, #7c3aed)'
                    : '#aaa',
                  cursor: !isFormValid || isSubmitting ? 'not-allowed' : 'pointer'
                }}
                className='submitBtn'
              >
                {isSubmitting ? (
                  <>
                    <div className='spinner'></div>
                    Publishing...
                  </>
                ) : (
                  <>
                    <Save size={20} />
                    Publish Blog Post
                  </>
                )}
              </button>
            </div>
          </div>
        </div>

        {/* Form Status */}
        <div className='statusBox'>
          <h3 className='statusTitle'>Form Status</h3>
          <div className='statusGrid'>
            {['title', 'date', 'imageUrl', 'description'].map((field) => (
              <div
                key={field}
                style={{
                  //...styles.,
                  color: formData[field] ? '#16a34a' : '#999'
                }}
                className='statusItem'
              >
                <div
                  style={{
                    //...styles.statusDot,
                    backgroundColor: formData[field] ? '#16a34a' : '#ccc'
                  }}
                  className='statusDot'
                />
                <span className='statusLabel'>{field.charAt(0).toUpperCase() + field.slice(1)}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

// const styles = {
//   container: {
//     minHeight: '100vh',
//     backgroundColor: '#f9fafb',
//     padding: '2rem',
//   },
//   wrapper: {
//     maxWidth: '960px',
//     margin: '0 auto',
//   },
//   card: {
//     backgroundColor: '#fff',
//     borderRadius: '1rem',
//     boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
//     overflow: 'hidden',
//   },
//   header: {
//     background: 'linear-gradient(to right, #2563eb, #7c3aed)',
//     color: '#fff',
//     padding: '2rem',
//   },
//   headerTitle: {
//     fontSize: '1.75rem',
//     fontWeight: 'bold',
//     display: 'flex',
//     alignItems: 'center',
//     gap: '0.75rem',
//   },
//   headerSubtext: {
//     color: '#c7d2fe',
//     marginTop: '0.5rem',
//   },
//   content: {
//     padding: '2rem',
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '2rem',
//   },
//   label: {
//     display: 'block',
//     fontSize: '0.95rem',
//     fontWeight: '600',
//     marginBottom: '0.5rem',
//   },
//   input: {
//     width: '100%',
//     padding: '0.75rem',
//     border: '2px solid #e5e7eb',
//     borderRadius: '0.5rem',
//     fontSize: '1rem',
//     outline: 'none',
//   },
//   uploadBox: {
//     border: '2px dashed #ccc',
//     padding: '1.5rem',
//     borderRadius: '1rem',
//     cursor: 'pointer',
//     textAlign: 'center',
//     position: 'relative',
//   },
//   uploadLabel: {
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center',
//   },
//   uploadText: {
//     fontSize: '1rem',
//     fontWeight: '500',
//     color: '#444',
//   },
//   uploadSubtext: {
//     fontSize: '0.85rem',
//     color: '#888',
//   },
//   imagePreview: {
//     maxWidth: '300px',
//     maxHeight: '200px',
//     borderRadius: '0.5rem',
//     boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
//   },
//   imageOverlay: {
//     position: 'absolute',
//     top: 0,
//     left: 0,
//     width: '100%',
//     height: '100%',
//     backgroundColor: 'rgba(0,0,0,0.4)',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     borderRadius: '0.5rem',
//     opacity: 0,
//     transition: 'opacity 0.3s ease',
//   },
//   successText: {
//     marginTop: '0.5rem',
//     color: '#16a34a',
//     fontWeight: '500',
//     fontSize: '0.9rem',
//   },
//   charCount: {
//     fontSize: '0.85rem',
//     color: '#666',
//     marginTop: '0.5rem',
//   },
//   toggleBtn: {
//     padding: '0.5rem 1rem',
//     backgroundColor: '#eee',
//     border: 'none',
//     borderRadius: '0.5rem',
//     display: 'flex',
//     alignItems: 'center',
//     fontWeight: '500',
//   },
//   previewBox: {
//     border: '2px solid #ddd',
//     borderRadius: '0.75rem',
//     padding: '1.5rem',
//     backgroundColor: '#f3f4f6',
//   },
//   previewHeading: {
//     fontSize: '1.1rem',
//     fontWeight: '600',
//     marginBottom: '1rem',
//     color: '#444',
//   },
//   previewCard: {
//     backgroundColor: '#fff',
//     padding: '1.5rem',
//     borderRadius: '0.75rem',
//     boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
//   },
//   previewTitle: {
//     fontSize: '1.5rem',
//     fontWeight: 'bold',
//     color: '#333',
//     marginBottom: '0.5rem',
//   },
//   previewDate: {
//     color: '#666',
//     marginBottom: '1rem',
//   },
//   previewImage: {
//     width: '100%',
//     height: '260px',
//     objectFit: 'cover',
//     borderRadius: '0.5rem',
//     marginBottom: '1rem',
//   },
//   previewText: {
//     color: '#444',
//     lineHeight: '1.6',
//     marginBottom: '1rem',
//   },
//   submitBox: {
//     display: 'flex',
//     justifyContent: 'flex-end',
//     marginTop: '2rem',
//     borderTop: '1px solid #eee',
//     paddingTop: '1.5rem',
//   },
//   submitBtn: {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '0.5rem',
//     padding: '0.75rem 1.5rem',
//     fontSize: '1rem',
//     color: '#fff',
//     border: 'none',
//     borderRadius: '0.5rem',
//     fontWeight: '600',
//     transition: 'all 0.3s ease',
//   },
//   spinner: {
//     width: '1.25rem',
//     height: '1.25rem',
//     border: '2px solid white',
//     borderTop: '2px solid transparent',
//     borderRadius: '50%',
//     animation: 'spin 1s linear infinite',
//   },
//   statusBox: {
//     marginTop: '2rem',
//     backgroundColor: '#fff',
//     padding: '1.5rem',
//     borderRadius: '0.75rem',
//     boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
//   },
//   statusTitle: {
//     fontWeight: '600',
//     color: '#333',
//     marginBottom: '1rem',
//   },
//   statusGrid: {
//     display: 'grid',
//     gridTemplateColumns: 'repeat(4, 1fr)',
//     gap: '1rem',
//   },
//   statusItem: {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '0.5rem',
//     fontSize: '0.85rem',
//   },
//   statusDot: {
//     width: '0.5rem',
//     height: '0.5rem',
//     borderRadius: '999px',
//   },
//   statusLabel: {
//     fontSize: '0.85rem',
//   }
// };

